import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-items-white mt-6 max-sm:px-5 max-sm:py-6 md:p-8',
    text: 'heading-s',
    header: 'sm:heading-m-bold heading-s-bold mb-4 flex items-center gap-3',
    recommendedProduct: 'mt-6'
  }
});
